import { InjectionToken } from '@angular/core';
import { LearnosityAuthorConfigInterface, LearnosityItemsConfigInterface } from '@campus/dal';
import {
  AuthorAppInterface,
  GradingAppInterface,
  ItemsAppInterface,
  LearnosityCallbacksInterface,
} from '../interfaces';

declare global {
  interface Window {
    LearnosityReports: {
      init: (object, string: string) => {};
    };
    LearnosityItems: LearnosityItemsWindowInterface;
    LearnosityGrading: LearnosityGradingWindowInterface;
    LearnosityAuthor: LearnosityAuthorWindowInterface;
    ReadSpeaker?: {
      ui?: {
        destroyActivePlayer?: () => void;
      };
    };
    rsCallbacks?: {
      readyListener?: () => void;
    }; // Readspeaker callback
    rspkr?: any;
    rsConf?: {
      Learnosity?: {
        customerParams?: {
          customerid?: string;
          region?: string;
          lang?: string;
          voice?: string;
          speed?: number;
          dict?: string;
          rule?: string;
          xslrule?: string;
        };
        useIcons?: boolean;
        positionIcon?: string;
        addSkip?: string;
        readSelector?: string[];
        revision?: string;
      };
      params?: string;
      ui?: any;
      general?: {
        cookieName?: string;
        usePost?: boolean;
        uiLang?: string;
        preserveElements?: string;
      };
    };
    itemsApp: ItemsAppInterface;
    gradingApp: GradingAppInterface;
    getAuthorApp: () => AuthorAppInterface;
  }
}

export interface LearnosityItemsWindowInterface {
  init: (
    object: LearnosityItemsConfigInterface,
    string: string,
    callbacksObject?: LearnosityCallbacksInterface
  ) => ItemsAppInterface;
}

export interface LearnosityGradingWindowInterface {
  init: (object: LearnosityItemsConfigInterface) => Promise<GradingAppInterface>;
}

export interface LearnosityAuthorWindowInterface {
  init: (
    object: LearnosityAuthorConfigInterface,
    string: string,
    callbacksObject?: LearnosityCallbacksInterface
  ) => AuthorAppInterface;
}

export const LEARNOSITY_WINDOW = new InjectionToken('WindowToken', {
  providedIn: 'root',
  factory: () => window,
});
